import { Reducer } from 'redux'
import { INSURANCE_UPDATE_ACTION_TYPES } from 'utils/actions/carrier'

const defaultState = {
  showDialog: false,
  updating: false,
  updateError: undefined,
}

const {
  CARRIER_INSURANCE_UPDATE_FAILURE,
  CARRIER_INSURANCE_UPDATE_REQUEST,
  CARRIER_INSURANCE_UPDATE_SUCCESS,
} = INSURANCE_UPDATE_ACTION_TYPES

const carrierInsuranceDialogReducer: Reducer<any, any> = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'OPEN_EDIT_INSURANCE_DIALOG':
      return {
        ...state,
        showDialog: true,
        updateError: undefined,
      }

    case 'CLOSE_EDIT_INSURANCE_DIALOG':
      return {
        ...state,
        showDialog: false,
      }

    case CARRIER_INSURANCE_UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
        updateError: undefined,
      }

    case CARRIER_INSURANCE_UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        showDialog: false,
      }

    case CARRIER_INSURANCE_UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        updateError: action.error,
      }

    default:
      return state
  }
}

export default carrierInsuranceDialogReducer
